
(() => {
  function patchCachedNavigation() {
    document.querySelectorAll(".shopify-section-group-header-group.header-section, #shopify-section-header, header-component").forEach((node) => {
      if (!node.closest(".mh-site-header")) node.remove();
    });
    document.querySelectorAll('a[href*="/pages/product-catalog"], a[href*="/pages/products"], a[href*="/pages/oriented-silicon-steel"], a[href*="/pages/non-oriented-silicon-steel"], a[href*="/products/oriented-silicon-steel"], a[href*="/products/non-oriented-silicon-steel"], a[href*="/collections/oriented-silicon-steel"], a[href*="/collections/non-oriented-silicon-steel"], a[href="/collections"], a[href="/collections/all"]').forEach((link) => {
      link.href = "/pages/electrical-steel-products";
      link.setAttribute("href", "/pages/electrical-steel-products");
    });
    document.querySelectorAll(".mh-site-nav").forEach((nav) => {
      nav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/electrical-steel-products">Products</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    });
    document.querySelectorAll(".mh-site-mobile__panel").forEach((nav) => {
      nav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/electrical-steel-products">Products</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    });
  }

  function patchCachedAboutPage() {
    if (window.location.pathname !== "/pages/about") return;
    const pageText = document.body ? document.body.innerText : "";
    if (!pageText.includes("Electrical steel supply, processing and export support for overseas B2B buyers.")) return;

    const mainSection = document.querySelector(".mh-page-hero--about")?.closest(".shopify-section");
    if (mainSection) {
      mainSection.innerHTML = `
        <div class="mh-b2b">
          <section class="mh-page-hero mh-page-hero--about">
            <div class="mh-container">
              <p class="mh-eyebrow">Company profile</p>
              <h1>Electrical steel supply and RFQ support for overseas buyers.</h1>
              <p>MH Electrical Steel helps trading companies, distributors and factories review GOES / CRGO, NOES, slit coil, lamination and transformer core inquiries before quotation.</p>
              <div class="mh-hero-actions">
                <a class="mh-btn mh-btn--primary" href="/pages/request-a-quote">Request Company Support</a>
                <a class="mh-btn mh-btn--secondary" href="/pages/quality-inspection-packaging">View Quality Documents</a>
              </div>
            </div>
          </section>
          <section class="mh-section">
            <div class="mh-container mh-grid-2">
              <div>
                <p class="mh-eyebrow">Who we serve</p>
                <h2>Built for buyers who need facts before price discussion.</h2>
                <p>Check product route, grade reference, documents and export packing first. Then send a complete RFQ.</p>
                <div class="mh-process-list">
                  <div><b>1</b><span>GOES / CRGO and non-oriented electrical steel inquiries.</span></div>
                  <div><b>2</b><span>Slitting, lamination, cut sheet and transformer core routes.</span></div>
                  <div><b>3</b><span>MTC, COA, inspection, label, packing and loading proof support.</span></div>
                </div>
              </div>
              <figure class="mh-proof-photo">
                <img src="//mhelectricalsteel.com/cdn/shop/t/9/assets/mh-company-proof.jpg" alt="MH Electrical Steel office and company proof">
                <figcaption>Company and office proof prepared for buyer verification.</figcaption>
              </figure>
            </div>
          </section>
          <section class="mh-section mh-band">
            <div class="mh-container">
              <div class="mh-section-head">
                <div><p class="mh-eyebrow">Company strength</p><h2>Clear support for international RFQs.</h2></div>
                <p>Procurement teams need quick answers on material route, documents and shipment readiness.</p>
              </div>
              <div class="mh-grid-4">
                <article class="mh-card"><h3>Supply scope</h3><p>Mother coil, slit coil, lamination material and transformer core support.</p></article>
                <article class="mh-card"><h3>Processing route</h3><p>Width matching, slitting, cutting, lamination review and packing preparation.</p></article>
                <article class="mh-card"><h3>Documents</h3><p>MTC, COA, inspection report, packing list, labels and loading photos by RFQ.</p></article>
                <article class="mh-card"><h3>Export reply</h3><p>Specification, destination port and document checks before quotation.</p></article>
              </div>
            </div>
          </section>
          <section class="mh-section">
            <div class="mh-container">
              <div class="mh-section-head">
                <div><p class="mh-eyebrow">Trade facts</p><h2>Practical information buyers check before an RFQ.</h2></div>
                <p>These facts help traders, distributors and factories decide whether to send a full inquiry.</p>
              </div>
              <div class="mh-grid-4">
                <article class="mh-card"><h3>Product scope</h3><p>GOES / CRGO, non-oriented electrical steel, mother coil, slitting coil, lamination and transformer core support.</p></article>
                <article class="mh-card"><h3>Reference MOQ</h3><p>25 tons as a working MOQ reference. Final MOQ depends on grade, width, processing route and availability.</p></article>
                <article class="mh-card"><h3>Lead time reference</h3><p>Stock material around 7-10 days, slitting around 10-15 days, mill-order material around 50 days.</p></article>
                <article class="mh-card"><h3>Trade terms</h3><p>FOB, CFR, CIF, T/T and L/C can be reviewed by destination, buyer status and order route.</p></article>
              </div>
            </div>
          </section>
          <section class="mh-section mh-band">
            <div class="mh-container">
              <div class="mh-section-head">
                <div><p class="mh-eyebrow">Buyer downloads</p><h2>Files buyers can use before sending an RFQ.</h2></div>
                <p>Use these resources for internal screening. Final availability must be confirmed by sales.</p>
              </div>
              <div class="mh-download-grid">
                <a class="mh-download-card" href="//mhelectricalsteel.com/cdn/shop/t/9/assets/mh-grade-baosteel-comparison.csv" download><strong>CSV - Baosteel grade comparison</strong><span>Quick import for internal screening</span></a>
                <a class="mh-download-card" href="//mhelectricalsteel.com/cdn/shop/t/9/assets/mh-grade-wisco-oriented-comparison.csv" download><strong>CSV - WISCO oriented grades</strong><span>Quick import for GOES / CRGO matching</span></a>
                <a class="mh-download-card" href="//mhelectricalsteel.com/cdn/shop/t/9/assets/mh-grade-wisco-non-oriented-comparison.csv" download><strong>CSV - WISCO non-oriented grades</strong><span>Quick import for NOES / NGO screening</span></a>
                <a class="mh-download-card" href="/pages/request-a-quote"><strong>Shougang / Ansteel reference</strong><span>Send target grade for matching review</span></a>
                <a class="mh-download-card" href="/pages/request-a-quote"><strong>RFQ checklist</strong><span>Required: product type and contact info. Recommended: grade, size, quantity and destination port.</span></a>
              </div>
            </div>
          </section>
          <section class="mh-section">
            <div class="mh-container mh-grid-2">
              <div>
                <p class="mh-eyebrow">Address</p>
                <h2>Shenzhen office contact route</h2>
                <p class="mh-address">6O, 6F, Building A, Guanghao International Center, Minzhi Street, Longhua District, Shenzhen, P.R.C. China</p>
                <p class="mh-note">This Shenzhen office route is used for sales communication, document coordination and buyer verification.</p>
              </div>
              <div class="mh-card">
                <h3>Unified sales contact</h3>
                <p>Email: <a href="mailto:info@mhelectricalsteel.com">info@mhelectricalsteel.com</a></p>
                <p>WhatsApp: <a href="https://wa.me/8613712853768" target="_blank" rel="noopener">+86 137 1285 3768</a></p>
                <p>Contact person: Sales Team</p>
              </div>
            </div>
          </section>
          <section class="mh-section mh-rfq-section">
            <div class="mh-container mh-rfq-layout">
              <div>
                <p class="mh-eyebrow">Next step</p>
                <h2>Send grade, size and destination details for review.</h2>
                <p>Required: product type and contact info. Recommended: grade or equivalent standard, thickness, width, quantity, destination port and document requirements.</p>
              </div>
              <div class="mh-card">
                <h3>Request support</h3>
                <p>Email: <a href="mailto:info@mhelectricalsteel.com">info@mhelectricalsteel.com</a></p>
                <p>WhatsApp: <a href="https://wa.me/8613712853768" target="_blank" rel="noopener">+86 137 1285 3768</a></p>
                <a class="mh-btn mh-btn--primary" href="/pages/request-a-quote">Open RFQ Page</a>
              </div>
            </div>
          </section>
        </div>
      `;
    }

    document.querySelectorAll(".mh-site-nav").forEach((nav) => {
      nav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/electrical-steel-products">Products</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    });
    document.querySelectorAll(".mh-site-mobile__panel").forEach((nav) => {
      nav.innerHTML = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/electrical-steel-products">Products</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
    });
    const footer = document.querySelector(".mh-site-footer");
    if (footer && !footer.innerText.includes("Shougang")) {
      footer.innerHTML = `
        <div class="mh-site-footer__inner">
          <div><h2>MH Electrical Steel</h2><p>GOES / CRGO and non-oriented electrical steel RFQ support for traders, distributors and factories.</p></div>
          <div><h3>Products</h3><a href="/pages/electrical-steel-products">Mother Coil</a><a href="/pages/electrical-steel-products">Slitting Coil</a><a href="/pages/electrical-steel-products">Lamination</a><a href="/pages/electrical-steel-products">Transformer Core</a></div>
          <div><h3>Quick links</h3><a href="/pages/electrical-steel-products#grades">Grades</a><a href="/pages/quality-inspection-packaging">Quality</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a></div>
          <div><h3>Mill & grade references</h3><p>Supply and grade matching discussions can reference Baosteel, Shougang, Ansteel and WISCO materials when buyers provide target standards and specifications.</p><a href="/pages/electrical-steel-products#grades">Baosteel / WISCO tables</a><a href="/pages/request-a-quote">Send target grade</a></div>
          <div><h3>Contact</h3><p>Email: <a href="mailto:info@mhelectricalsteel.com">info@mhelectricalsteel.com</a></p><p>WhatsApp: <a href="https://wa.me/8613712853768" target="_blank" rel="noopener">+86 137 1285 3768</a></p><p>6O, 6F, Building A, Guanghao International Center, Minzhi Street, Longhua District, Shenzhen, P.R.C. China</p></div>
        </div>
      `;
    }
  }

  patchCachedNavigation();
  patchCachedAboutPage();

  const panel = document.getElementById("mh-ai-panel");
  const openButtons = document.querySelectorAll("[data-mh-ai-open]");
  const close = document.querySelector("[data-mh-ai-close]");
  const body = document.querySelector("[data-mh-ai-body]");
  const buyerInput = document.querySelector("[data-mh-ai-buyer]");
  const messageInput = document.querySelector("[data-mh-ai-message]");
  const productSelect = document.querySelector(".mh-ai-form select[name='contact[Product type]']");
  const proxyEndpoint = window.MH_QWEN_PROXY_ENDPOINT || "";

  if (!panel || !body) return;

  const replies = {
    "Factory buyer": "For factory procurement, please include application, grade/standard, thickness, width, quantity, destination and document needs. If this is for transformer core, GOES / CRGO is usually the first route. For motor laminations, choose non-oriented electrical steel.",
    "Trading company": "For trading companies, please include target market, buyer type, grade, dimensions, quantity, packaging requirements and whether you need neutral documents or shipment proof.",
    "Need material recommendation": "Tell us the application first: transformer core, motor, generator, compressor, lamination or slitting. We will help match GOES / CRGO, non-oriented electrical steel or processing support and ask for the missing quotation details."
  };

  function addMessage(text, user = false) {
    const p = document.createElement("p");
    p.className = user ? "mh-ai-msg mh-ai-msg--user" : "mh-ai-msg";
    p.textContent = text;
    body.appendChild(p);
    body.scrollTop = body.scrollHeight;
  }

  async function askQwen(message, buyerType) {
    if (!proxyEndpoint) return null;
    try {
      const response = await fetch(proxyEndpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          buyerType,
          productType: productSelect ? productSelect.value : "",
          message
        })
      });
      if (!response.ok) return null;
      const data = await response.json();
      return data.reply || null;
    } catch {
      return null;
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", () => panel.classList.add("is-open"));
  });

  close?.addEventListener("click", () => {
    panel.classList.remove("is-open");
  });

  document.addEventListener("click", async (event) => {
    const option = event.target.closest("[data-mh-ai-option]");
    if (!option) return;
    const value = option.getAttribute("data-mh-ai-option");
    addMessage(value, true);
    if (buyerInput) buyerInput.value = value;
    if (messageInput && !messageInput.value.trim()) {
      messageInput.value = value + ". Product/application: ; grade/standard: ; thickness/width: ; quantity: ; destination: ; document needs: ";
      messageInput.focus();
    }
    addMessage("Checking the RFQ details...");
    const qwenReply = await askQwen(value, value);
    const messages = body.querySelectorAll(".mh-ai-msg");
    const last = messages[messages.length - 1];
    if (last && last.textContent === "Checking the RFQ details...") last.remove();
    addMessage(qwenReply || replies[value] || replies["Need material recommendation"]);
  });

  messageInput?.addEventListener("keydown", async (event) => {
    if (event.key !== "Enter" || event.shiftKey) return;
    const message = messageInput.value.trim();
    if (!message) return;
    event.preventDefault();
    addMessage(message, true);
    addMessage("Reviewing your RFQ...");
    const buyerType = buyerInput ? buyerInput.value : "";
    const qwenReply = await askQwen(message, buyerType);
    const messages = body.querySelectorAll(".mh-ai-msg");
    const last = messages[messages.length - 1];
    if (last && last.textContent === "Reviewing your RFQ...") last.remove();
    addMessage(qwenReply || "Please add product type and contact info. Grade/standard, thickness, width, quantity, destination and document needs help sales quote faster.");
  });
})();
